var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "manual-wrapper" },
    [
      _vm._t("title"),
      _vm._v(" "),
      _c("div", { staticClass: "width-expander" }, [
        _vm.manualCableSelectionOfferings.length > 0
          ? _c(
              "div",
              { staticClass: "flex-wrapper" },
              [
                _vm.activeProductKey === "AG52" ||
                (_vm.activeProductKey === "AG-CBL" &&
                  _vm.selectedTypeOfReplacementCable.includes("52"))
                  ? _c("div", { staticClass: "new-cable-message" }, [
                      _vm._v(
                        _vm._s(
                          _vm.webstoreContent.cartPage.new_ag_cable_message
                        )
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(
                  _vm.manualCableSelectionOfferings,
                  function (cableInfo, count) {
                    return _c(
                      "div",
                      {
                        key: count,
                        staticClass: "tile-wrapper",
                        attrs: { id: cableInfo.skuText },
                      },
                      [
                        !_vm.isCableAccessoriesPage
                          ? _c(
                              "div",
                              [
                                _c("CableSelectQuantity", {
                                  ref: cableInfo.skuText.replace(/\-/g, ""),
                                  refInFor: true,
                                  attrs: {
                                    imageSource: cableInfo.image,
                                    productName: cableInfo.productName,
                                    skuText: cableInfo.skuText,
                                    maxPurchasableQuantity:
                                      _vm.cablesNeededCount,
                                    minPurchasableQuantity: 0,
                                    maxedOut:
                                      _vm.cablesNeededCount ===
                                      _vm.cablesSelectedCount,
                                    startingNumber:
                                      _vm.manualSelectionData &&
                                      cableInfo.skuText in
                                        _vm.manualSelectionData
                                        ? _vm.manualSelectionData[
                                            cableInfo.skuText
                                          ]
                                        : 0,
                                  },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              [
                                _c("CableSelectQuantity", {
                                  ref: cableInfo.skuText.replace(/\-/g, ""),
                                  refInFor: true,
                                  attrs: {
                                    imageSource: cableInfo.image,
                                    productName: cableInfo.productName,
                                    skuText: cableInfo.skuText,
                                    maxPurchasableQuantity:
                                      Number.MAX_SAFE_INTEGER,
                                    minPurchasableQuantity: 0,
                                    maxedOut: false,
                                    startingNumber:
                                      _vm.manualSelectionData &&
                                      cableInfo.skuText in
                                        _vm.manualSelectionData
                                        ? _vm.manualSelectionData[
                                            cableInfo.skuText
                                          ]
                                        : 0,
                                  },
                                }),
                              ],
                              1
                            ),
                      ]
                    )
                  }
                ),
              ],
              2
            )
          : _c("div", [
              _c("p", [
                _vm._v(
                  _vm._s(_vm.webstoreContent.cartPage.no_cables) +
                    " " +
                    _vm._s(
                      _vm.isCableAccessoriesPage &&
                        _vm.webstoreContent.cartPage.cable_type
                    )
                ),
              ]),
            ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }